import { client } from '@atlassian/rovo-content-bridge-api';

export const HELP_CENTER_FORM_REQUEST_CLIENT_ID = client('help-center-form-content-renderer');
